import Lenis from 'lenis';
import { gsap } from 'gsap';
import { ScrollTrigger } from 'gsap/ScrollTrigger';
gsap.registerPlugin(ScrollTrigger);

export default class SmoothScroll {
  constructor() {
    this.lenis = null;
    this.init();
  }

  init() {
    this.lenis = new Lenis({
      duration: 1,
      easing: (x) => x === 1 ? 1 : 1 - Math.pow(2, -10 * x),   //easeOutQuad
      autoRaf: false,                          // 手動でRAF制御する
    });

    this.lenis.on('scroll', ScrollTrigger.update);

    // ページ完全読み込み後に開始
    window.addEventListener('load', () => {
      this.startRAF();
      setTimeout(() => this.lenis.resize(), 100);
    });
  }

  startRAF() {
    const loop = (time) => {
      if (this.lenis){
        this.lenis.raf(time);
      }
      requestAnimationFrame(loop);
    };
    requestAnimationFrame(loop);
  }
}
